import initSequentialLottie from '../parts/lottie-sequence';
const SELECTOR_SECTION = '.block-outcomes';
const init = () => initSequentialLottie(SELECTOR_SECTION, { viewportSelector: '.block-outcomes__grid' });
document.addEventListener('DOMContentLoaded', init);
if (window.acf) {
    window.acf.addAction('render_block_preview', init);
}
export default init;
